import ReactGA from "react-ga4";

const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export const initGA = () => {
  if (!MEASUREMENT_ID) return;
  ReactGA.initialize(MEASUREMENT_ID, { gtagOptions: { send_page_view: false } });
};

// Collapse dynamic IDs so each patient/graph doesn't become a separate page
const normalizePath = (pathname) =>
  pathname
    .replace(/\/graph\/[^/]+/, "/graph/:patientID")
    .replace(/\/patient\/[^/]+/, "/patient/:patientID")
    .replace(/\/partograph\/[^/]+/, "/partograph/:patientID");

export const trackPageView = (pathname) => {
  if (!MEASUREMENT_ID) return;
  ReactGA.send({ hitType: "pageview", page: normalizePath(pathname) });
};